import { PANEL_GROUPS } from '../layoutManager';

// Map layout panel groups to icons/graphics
const GROUP_ICONS = {
  'Overview': '📊',
  'Time': '🕐',
  'Calendar': '📅',
  'Weather & Traffic': '🌤',
  'Markets & News': '📈',
  'Financial': '💰',
  'Airbnb': '🏠',
  'Goals': '🎯',
  'Receipts & Packages': '📦',
  'Shopping & Lists': '🛒',
  'Wedding': '💍',
  'Notifications': '🔔',
  'Other': '🔧',
};

const GROUP_COLORS = {
  'Overview': '#8b5cf6',
  'Time': '#71717a',
  'Calendar': '#3b82f6',
  'Weather & Traffic': '#06b6d4',
  'Markets & News': '#22c55e',
  'Financial': '#f59e0b',
  'Airbnb': '#ef4444',
  'Goals': '#f97316',
  'Receipts & Packages': '#a855f7',
  'Shopping & Lists': '#10b981',
  'Wedding': '#ec4899',
  'Notifications': '#eab308',
  'Other': '#71717a',
};

function getLayoutGroups(layout) {
  if (!layout || !layout.order) return [];
  const visiblePanels = layout.order.filter(id => !(layout.hidden || []).includes(id));
  const groups = new Set();
  for (const [group, panelIds] of Object.entries(PANEL_GROUPS)) {
    if (panelIds.some(id => visiblePanels.includes(id))) {
      groups.add(group);
    }
  }
  return [...groups];
}

function getPrimaryGroup(layout) {
  const groups = getLayoutGroups(layout);
  // Skip generic groups, prefer specific ones
  const specific = groups.filter(g => g !== 'Time' && g !== 'Other' && g !== 'Notifications');
  return specific[0] || groups[0] || 'Other';
}

function LayoutNavigator({ layouts, currentIndex, onNavigate }) {
  if (!layouts || layouts.length <= 1) {
    return (
      <section className="card">
        <h2>Layouts</h2>
        <p style={{ color: '#71717a', fontSize: 13 }}>Create additional layouts to navigate between them.</p>
      </section>
    );
  }

  return (
    <section className="card ln-section">
      <h2>Layouts</h2>
      <div className="ln-grid">
        {layouts.map((layout, i) => {
          const isCurrent = i === currentIndex;
          const primary = getPrimaryGroup(layout);
          const groups = getLayoutGroups(layout);
          const color = GROUP_COLORS[primary] || '#71717a';
          const icon = GROUP_ICONS[primary] || '📋';

          return (
            <button
              key={i}
              className={`ln-card${isCurrent ? ' ln-active' : ''}`}
              onClick={() => !isCurrent && onNavigate(i)}
              style={{ '--ln-color': color }}
            >
              <div className="ln-icon">{icon}</div>
              <div className="ln-name">{layout.name}</div>
              <div className="ln-groups">
                {groups.slice(0, 4).map(g => (
                  <span key={g} className="ln-group-dot" style={{ background: GROUP_COLORS[g] || '#71717a' }} title={g} />
                ))}
                {groups.length > 4 && <span className="ln-group-more">+{groups.length - 4}</span>}
              </div>
              <div className="ln-panel-count">
                {layout.order.filter(id => !(layout.hidden || []).includes(id)).length} panels
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default LayoutNavigator;
